import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const MOBILE_APPBAR_HEIGHT = 56;
const MOBILE_HEADER_HEIGHT = 58;

const useStyles = makeStyles(theme => ({
  ticketHeader: {
    flex: "0 0 auto",
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 900,

    background:
      theme.mode === "light"
        ? "rgba(255,255,255,.96)"
        : "rgba(15,23,42,.96)",

    borderBottom:
      theme.mode === "light"
        ? "1px solid #E4E7EC"
        : "1px solid rgba(148,163,184,.18)",

    boxShadow:
      theme.mode === "light"
        ? "0 2px 8px rgba(16,24,40,.05)"
        : "0 4px 14px rgba(0,0,0,.18)",

    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    transform: "translateZ(0)",
    WebkitTransform: "translateZ(0)",

    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      top: MOBILE_APPBAR_HEIGHT,
      left: 0,
      right: 0,
      height: MOBILE_HEADER_HEIGHT,
      borderRadius: 0
    }
  },

  mobileSpacer: {
    display: "none",

    [theme.breakpoints.down("sm")]: {
      display: "block",
      height: MOBILE_HEADER_HEIGHT,
      flex: "0 0 auto"
    }
  },

  topBar: {
    minHeight: 58,
    height: 58,
    padding: "6px 10px",

    display: "flex",
    alignItems: "center",
    gap: 6,

    boxSizing: "border-box",
    background: "transparent",

    [theme.breakpoints.down("sm")]: {
      minHeight: MOBILE_HEADER_HEIGHT,
      height: MOBILE_HEADER_HEIGHT,
      padding: "5px 6px",
      gap: 4
    }
  }
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();

  if (loading) return <TicketHeaderSkeleton />;

  return (
    <>
      <div className={classes.ticketHeader}>
        <div className={classes.topBar}>{children}</div>
      </div>

      <div className={classes.mobileSpacer} />
    </>
  );
};

export default TicketHeader;
